export default "icons-camera"